/**
 * Bewegungs-Vorlieben des Nutzers — EINE Fassung fuer die ganze Bibliothek.
 *
 * Es gab zwei, und sie waren nicht gleich gut: `lib/theme-transition.ts:184`
 * prueft nur `typeof window !== "undefined"` und wirft damit ueberall, wo es ein
 * `window` ohne `matchMedia` gibt (Testumgebungen, alte WebViews).
 * `workspace/WorkspaceWheel.tsx:145` hatte die Wache und die Begruendung dazu —
 * die abgesicherte Fassung ist deshalb die, die hier steht (GUI-A-12).
 *
 * Eigenes Modul und nicht in `theme-transition.ts`: das Rad braucht die Abfrage
 * an fuenf Stellen und haette sonst den ganzen Uebergangs-Apparat im
 * Modulgraphen. Muster ist `lib/wheel-timing.ts`.
 */
export function prefersReducedMotion(): boolean {
  // `matchMedia` fehlt in Testumgebungen und alten WebViews — dort einfach
  // normale Bewegung annehmen, statt beim Oeffnen zu werfen.
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
